module.exports = __webpack_public_path__ + "img/scene5-15.b2354385.jpg";